import { useEffect, useMemo, useRef, useState } from 'react'

/**
 *
 * @param direction 1: portrait, 2:landscape
 */
export default function useScreenOrientation(direction: number): {
  angle: number | undefined
  rotateClassName: string
  rotationDegree: number
} {
  const listener = useRef<((event: Event) => void) | null>(null)
  const [angle, setAngle] = useState<number | undefined>(window.screen.orientation?.angle)
  const [type, setType] = useState<string | undefined>(window.screen.orientation?.type)

  useEffect(() => {
    window.screen.orientation?.addEventListener('change', (event: Event) => {
      const angle = (event.target as ScreenOrientation).angle
      const type = (event.target as ScreenOrientation).type
      setAngle(angle)
      setType(type)
    })
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      window.screen.orientation?.removeEventListener('change', listener.current as EventListenerOrEventListenerObject)
    }
  }, [])

  const rotateClassName = useMemo(() => {
    if (direction === 1 && angle === 90) {
      // portrait 90deg
      return 'rotate-270'
    } else if (direction === 1 && angle === 270) {
      // portrait 270deg
      return 'rotate-90'
    } else if (direction === 2 && (angle === 0 || angle === 180) && type !== 'landscape-primary') {
      // landscape
      return 'rotate-90'
    }
    return 'rotate-0'
  }, [direction, angle, type])

  const rotationDegree = useMemo(() => {
    if (direction === 1 && angle === 90) {
      // portrait 90deg
      return 270
    } else if (direction === 1 && angle === 270) {
      // portrait 270deg
      return 90
    } else if (direction === 2 && (angle === 0 || angle === 180) && type !== 'landscape-primary') {
      // landscape
      return 90
    }
    return 0
  }, [direction, angle, type])

  return { angle, rotateClassName, rotationDegree }
}
